export default {
  mounted() {
    // Focus the input element
    this.el.focus()
    // Move the cursor to the end of the text in the input
    const value = this.el.value // Get the current value of the input
    this.el.value = '' // Temporarily clear the value
    this.el.value = value // Re-assign the value to move cursor to the end
  },
}
